<template>
  <div>
    <div class="openStep">
      <el-button
        @click="moveLeft"
        :class="[rightClickNum == 0 ? 'disabledLeftArrow' : 'leftArrow']"
        :disabled="leftDisabled"
      ></el-button>
      <div class="one" v-show="isOneShow">
        <div class="circle check_circle">
          <div class="circle1">1</div>
        </div>
        <span
          :class="check_page >= 0 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[0] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isOneShow"></span>
      <span class="circleSmall circleSmall2" v-show="isOneShow"></span>
      <span class="circleSmall circleSmall3" v-show="isOneShow"></span>
      <div class="two" v-show="isTwoShow">
        <div :class="check_page >= 1 ? 'circle check_circle' : 'circle'">
          <div class="circle1">2</div>
        </div>
        <span
          :class="check_page >= 1 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[1] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isTwoShow"></span>
      <span class="circleSmall circleSmall2" v-show="isTwoShow"></span>
      <span class="circleSmall circleSmall3" v-show="isTwoShow"></span>
      <div class="three" v-show="isThreeShow">
        <div :class="check_page >= 2 ? 'circle check_circle' : 'circle'">
          <div class="circle1">3</div>
        </div>
        <span
          :class="check_page >= 2 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[2] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isThreeShow"></span>
      <span class="circleSmall circleSmall2" v-show="isThreeShow"></span>
      <span class="circleSmall circleSmall3" v-show="isThreeShow"></span>
      <div class="four" v-show="isFourShow">
        <div :class="check_page >= 3 ? 'circle check_circle' : 'circle'">
          <div class="circle1">4</div>
        </div>
        <span
          :class="check_page >= 3 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[3] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isFourShow"></span>
      <span class="circleSmall circleSmall2" v-show="isFourShow"></span>
      <span class="circleSmall circleSmall3" v-show="isFourShow"></span>
      <div class="five" v-show="isFiveShow">
        <div :class="check_page >= 4 ? 'circle check_circle' : 'circle'">
          <div class="circle1">5</div>
        </div>
        <span
          :class="check_page >= 4 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[4] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isShow"></span>
      <span class="circleSmall circleSmall2" v-show="isShow"></span>
      <span class="circleSmall circleSmall3" v-show="isShow"></span>
      <div class="six" v-show="isSixShow">
        <div :class="check_page >= 5 ? 'circle check_circle' : 'circle'">
          <div class="circle1">6</div>
        </div>
        <span
          :class="check_page >= 5 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[5] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isSevenShow"></span>
      <span class="circleSmall circleSmall2" v-show="isSevenShow"></span>
      <span class="circleSmall circleSmall3" v-show="isSevenShow"></span>
      <div class="seven" v-show="isSevenShow">
        <div :class="check_page >= 6 ? 'circle check_circle' : 'circle'">
          <div class="circle1">7</div>
        </div>
        <span
          :class="check_page >= 6 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[6] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isEightShow"></span>
      <span class="circleSmall circleSmall2" v-show="isEightShow"></span>
      <span class="circleSmall circleSmall3" v-show="isEightShow"></span>
      <!-- <div class="eight" v-show="isEightShow">
        <div :class="check_page >= 7 ? 'circle check_circle' : 'circle'">
          <div class="circle1">8</div>
        </div>
        <span
          :class="check_page >= 7 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[7] }}</span
        >
      </div>
      <span class="circleSmall circleSmall1" v-show="isNineShow"></span>
      <span class="circleSmall circleSmall2" v-show="isNineShow"></span>
      <span class="circleSmall circleSmall3" v-show="isNineShow"></span>

      <div class="nine" v-show="isNineShow && isChinese === 'zh-cn'">
        <div :class="check_page >= 8 ? 'circle check_circle' : 'circle'">
          <div class="circle1">9</div>
        </div>
        <span
          :class="check_page >= 8 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[8] }}</span
        >
      </div>
      <span
        class="circleSmall circleSmall1"
        v-show="isTenShow && isChinese === 'zh-cn'"
      ></span>
      <span
        class="circleSmall circleSmall2"
        v-show="isTenShow && isChinese === 'zh-cn'"
      ></span>
      <span
        class="circleSmall circleSmall3"
        v-show="isTenShow && isChinese === 'zh-cn'"
      ></span> -->


      <div class="ten" v-show="isTenShow">
        <div :class="check_page >= 9 ? 'circle check_circle' : 'circle'">
          <div class="circle1">{{ 8 }}</div>
        </div>
        <span
          :class="check_page >= 9 ? ' check_stepTxt' : 'stepTxt'"
          :style="isLanguage"
          >{{ $t("page.supReg.stepName")[9] }}</span
        >
      </div>
      <el-button
        :class="[
          rightClickNum == 5 || rightClickNum == 10
            ? 'disabledRightArrow'
            : 'rightArrow'
        ]"
        :disabled="rightDisabled"
        @click="moveRight"
      ></el-button>
    </div>
  </div>
</template>

<script>
import globalConfig from "@/setting/setting";
import Cookies from "js-cookie";
const savedLocaleKey = globalConfig.i18n.cookieLable;

export default {
  props: {
    check_page: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOneShow: true,
      isTwoShow: true,
      isThreeShow: true,
      isFourShow: true,
      isFiveShow: true,
      isSixShow: false,
      isSevenShow: false,
      isEightShow: false,
      isNineShow: false,
      isTenShow: false,
      isShow: false,
      rightClickNum: 0,
      leftDisabled: false,
      rightDisabled: false,
      isNext: window.sessionStorage.getItem("next"),
      isChinese: Cookies.get(savedLocaleKey)
    };
  },
  components: {},
  created() {
    this.isNext = window.sessionStorage.getItem("next");
      this.msgCenter.$on('ballMoveRight',this.moveRight)
  },
  computed: {
    isLanguage() {
      if (Cookies.get(savedLocaleKey) === "zh-cn") {
        return { "white-space": "nowrap" };
      } else {
        return {
          "-webkit-line-clamp": 2,
          "-webkit-box-orient": "vertical"
        };
      }
    }
  },
  mounted() {},
  methods: {
    moveLeft() {
      this.rightClickNum--;
      if (this.rightClickNum == 4) {
        this.isTenShow = false;
        this.isFiveShow = true;
        this.isShow = true;
        this.rightDisabled = false;
      } else if (this.rightClickNum == 3) {
        this.isNineShow = false;
        this.isFourShow = true;
        this.rightDisabled = false;
      } else if (this.rightClickNum == 2) {
        this.isEightShow = false;
        this.isThreeShow = true;
        this.rightDisabled = false;
      } else if (this.rightClickNum == 1) {
        this.isSevenShow = false;
        this.isTwoShow = true;
        this.rightDisabled = false;
      } else if (this.rightClickNum == 0) {
        this.isSixShow = false;
        this.isOneShow = true;
        this.leftDisabled = true;
        this.isShow = false;
        this.rightDisabled = false;
      }
    },
    moveRight() {
      console.log('moveRightmoveRight');
      
      this.rightClickNum++;
      if (this.rightClickNum == 1) {
        this.isOneShow = false;
        this.isShow = true;
        this.isSixShow = true;
        this.leftDisabled = false;
      } else if (this.rightClickNum == 2) {
        this.isTwoShow = false;
        this.isSevenShow = true;
        this.leftDisabled = false;
      } else if (this.rightClickNum == 3) {
        this.isThreeShow = false;
        this.isEightShow = true;
        this.leftDisabled = false;
      } else if (this.rightClickNum == 4) {
        this.isFourShow = false;
        this.isNineShow = true;
        this.leftDisabled = false;
      } else if (this.rightClickNum == 5) {
        this.isFiveShow = false;
        this.isTenShow = true;
        this.rightDisabled = true;
        this.isShow = false;
        this.leftDisabled = false;
      }
    },
    // 判断是否中文
    pattern(str) {
      const reg = new RegExp("[\u4E00-\u9FA5]");
      if (reg.test(str)) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    rightClickNum: {
      handler() {
        if (this.rightClickNum == 0) {
          this.leftDisabled = true;
        }
      },
      immediate: true
    },
    check_page: {
      handler(newval,oldValue) {
  
     
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../css/index.scss";  
> html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
  height: 100%;
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* header */
.header {
  min-width: 1260px;
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
/* openStep */
.openStep {
  width: 760px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 210px;
  position: relative;
}
.openStep .circle {
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background: rgb(255, 230, 233);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  /* opacity: 0.3; */
}

.openStep .circle1 {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: rgba(255, 255, 255, 1);
  background: rgb(255, 176, 171);
  line-height: 37px;
  text-align: center;
  line-height: 43px;
}
.openStep .check_circle .circle1 {
  background: linear-gradient(
    90deg,
    rgba(255, 20, 47, 1) 0%,
    rgba(255, 72, 20, 1) 100%
  );
}
.openStep .circleSmall {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 4px;
  background: rgba(221, 221, 221, 1);
  margin: 20px -8px;
  margin-top: -12px;
}
.openStep .stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.check_stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: rgba(255, 20, 47, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.openStep .leftArrow {
  width: 25px;
  height: 25px;
  border-left: 5px solid #ff142f;
  border-bottom: 5px solid #ff142f;
  transform: rotate(45deg);
  position: absolute;
  left: 157px;
  top: 50px;
  background-color: #fff;
}
.openStep .disabledLeftArrow {
  width: 25px;
  height: 25px;
  border-left: 5px solid #ddd;
  border-bottom: 5px solid #ddd;
  transform: rotate(45deg);
  position: absolute;
  left: 157px;
  top: 50px;
  background-color: #fff;
}
.openStep .rightArrow {
  width: 25px;
  height: 25px;
  border-right: 5px solid #ff142f;
  border-bottom: 5px solid #ff142f;
  transform: rotate(-45deg);
  position: absolute;
  right: 157px;
  top: 50px;
  background-color: #fff;
}
.openStep .disabledRightArrow {
  width: 25px;
  height: 25px;
  border-right: 5px solid #ddd;
  border-bottom: 5px solid #ddd;
  transform: rotate(-45deg);
  position: absolute;
  right: 157px;
  top: 50px;
  background-color: #fff;
}
/* content */
.sign-content {
  width: 1180px;
  height: 450px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;
  .one {
    margin-top: 20px;
    margin-left: 90px;
  }
  .two {
    margin-top: 20px;
    margin-left: 90px;
  }
  .three {
    margin-top: 45px;
    margin-left: 90px;
  }
  .four {
    margin-top: 42px;
    margin-left: 90px;
  }
  .five {
    margin-top: 44px;
    margin-left: 90px;
  }
}
.register1 {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  margin: 19px 0px 0px 70px;
}
.title {
  height: 25px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #4a4a4a;
  font-weight: 600;
}
.title p {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 400;
  margin-top: 6px;
  margin-left: 22px;
}

.right-btn {
  // position: absolute;
  // bottom: 20px;
  // left: 340px;
  position: relative;
  left: calc(50% - 250px);
  margin-bottom: 20px;
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  span {
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
}
.right-btn:hover {
  background: rgba(255, 20, 47, 1);
}
</style>
